module.exports = __webpack_public_path__ + "static/media/logo_full_black.92ed266e.png";